import { useRef } from "react";
import { connect } from "react-redux";
import { Warning } from "../../../../components/button";
import CreateAddress from "../create";
import addressImg from "../../../../assets/images/icon/address.svg";
import { EmptyMessage, EmptyAddress, EmptyImg } from "./style";

const Empty = (props) => {
  const createAddressRef = useRef();

  const { theme, addresses, setAddresses } = props;

  return (
    <>
      <CreateAddress
        refrence={createAddressRef}
        addresses={addresses}
        setAddresses={setAddresses}
      />
      <EmptyAddress className="text-center mt-4">
        <EmptyImg className="img-fluid" src={addressImg} alt="" />
        <EmptyMessage className="mt-2 f-13" theme={theme}>
          با ثبت نشانی‌های خود، روند خریدتان را سریع‌تر کنید
        </EmptyMessage>
        <Warning
          className="d-block w-75 mx-auto mt-3"
          title="آدرس جدید"
          onClick={() => createAddressRef.current.changeStatus()}
        />
      </EmptyAddress>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    theme: state.theme,
  };
};

export default connect(mapStateToProps)(Empty);
